"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeBridgeImpl = void 0;
const check_1 = __importDefault(require("./check"));
const moment_1 = __importDefault(require("moment"));
const Range_1 = require("./Range");
class DateTimeBridgeImpl {
    constructor() {
        this.convert = (value, from, into) => {
            if (from === into && (value === null || value === void 0 ? void 0 : value.length) === (into === null || into === void 0 ? void 0 : into.length)) {
                return value;
            }
            return (0, check_1.default)((0, moment_1.default)(value, from).format(into));
        };
        this.systemRange = ({ from, to }) => {
            return new Range_1.Range(this.systemDate(from), this.systemDate(to));
        };
        this.userRange = ({ from, to }) => {
            return new Range_1.Range(this.userDate(from), this.userDate(to));
        };
        this.setUserFormat = (format) => {
            this.userFormat = format;
        };
        this.setSystemFormat = (format) => {
            this.systemFormat = format;
        };
    }
    systemDate(date) {
        return this.convert(date, this.userFormat.date, this.systemFormat.date);
    }
    userDate(date) {
        return this.convert(date, this.systemFormat.date, this.userFormat.date);
    }
    userDateTime(dateTime) {
        return this.convert(dateTime, this.systemFormat.dateTime, this.userFormat.dateTime);
    }
}
exports.DateTimeBridgeImpl = DateTimeBridgeImpl;
//# sourceMappingURL=DateTimeBridge.js.map